export const TopBarConfig = {
    showAlert: true,
    alertText: "Explore New Patient Relationship Tool Features >>",
    secondaryAlertText: "", //Displays after alertText or after countdown timer when active
    clickUrl: "https://interface.cellcore.com",
    backgroundColor: "#A02EC6",
    textColor: "#FFF",
    fontSize: "16px",
    showCountDown: false,
    endDate: "", // Format: YYYY-MM-DD for better date parsing
    endTime: "",
    expiredText: "",
    backgroundImage: "",
    removeDate: "2025-09-10", // Format: YYYY-MM-DD - Top bar will be removed after this date
    timezone: "-06:00", // MST timezone offset
    underlineSecondaryText: true, // Controls whether secondary text is underlined
};
